
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".92"}},[_c('path',{attrs:{"d":"M30.828 21.504h.008l-.424-.787-5.416-10.254V4.261h3.326V.704H7.678V4.26h3.326v6.202L5.588 20.717l-.424.784h.007L.963 29.471v4.091h34.074v-4.09l-4.209-7.969zM14.71 11.257V4.261h6.58v6.996l4.465 8.463c-.146.011-.292.018-.452.018-1.884 0-4.188-2.175-7.303-2.175-3.116 0-5.42 2.175-7.303 2.175-.156 0-.306-.007-.452-.018l4.465-8.463zm-9.887 18.75l3.642-6.908c.534.125 1.086.2 1.67.2 3.083 0 5.284-2.176 7.865-2.176 2.581 0 4.782 2.176 7.865 2.176a7.1 7.1 0 001.67-.2l3.642 6.908H4.823z","fill":"#fff"}}),_c('path',{attrs:{"d":"M.963 33.567h34.074v-4.09L25 10.462V.703h-3.71v10.558l9.887 18.75H4.823l9.887-18.75V.704H11v9.759L.963 29.476v4.091z","fill":"#0037FF"}}),_c('path',{attrs:{"d":"M10.015 23.477c3.083 0 5.283-2.176 7.865-2.176 2.581 0 4.782 2.176 7.865 2.176 1.858 0 3.414-.666 4.97-1.798l-1.734-3.212c-1.388 1.011-2.271 1.45-3.802 1.45-1.884 0-4.187-2.176-7.303-2.176-3.115 0-5.419 2.175-7.302 2.175-1.531 0-2.414-.441-3.803-1.449L5.037 21.68c1.556 1.132 3.112 1.798 4.97 1.798h.008zM28.273.704H7.63V4.26h20.643V.704z","fill":"#0037FF"}})])])
          )
        }
      }
    